import { IWheelProps } from '~/actions/extraHTML/wheelOfFortune';
import { rotationElementsClass, rotationWheelClass } from '~/actions/extraHTML/wheelOfFortune/const';

interface IInitAnimationFunctions {
  prefix: string;
  iterator: number;
  wheelParams: IWheelProps;
  isMobile: boolean;
}

interface ISpinTheWheel extends Element {
  style: {[key: string]: string};
}

export const initAnimationEndFunctions = ({
  prefix,
  iterator,
  wheelParams,
  isMobile,
}: IInitAnimationFunctions) => {
  const spinTheWheelSelector = isMobile
    ? `.${prefix}notification_with_wheel_mobile_${iterator}  .__csa-notification__body  .${prefix}notification__button._type-primary`
    : `.${prefix}notification_with_wheel_desktop_${iterator}  .__csa-notification__body  .${prefix}notification__button._type-primary`;

  const spinTheWheel: ISpinTheWheel = document.querySelector(spinTheWheelSelector);

  const onWheelStopSpin = () => {

    const spinTheWheelListener = () => {

      const widgetSelector = isMobile
        ? `.${prefix}notification_with_wheel_mobile_${iterator}`
        : `.${prefix}notification_with_wheel_desktop_${iterator}`;

      const widget = document.querySelector(widgetSelector);

      if (wheelParams.animationProps.coupon) {
        navigator?.clipboard.writeText(wheelParams.animationProps.coupon);
        spinTheWheel.innerHTML = 'Скопирован';
        spinTheWheel.setAttribute('disabled', 'disabled');
        setTimeout(() => { widget.parentElement.classList.add('_hidden'); }, 1000);
      } else {
        widget.parentElement.classList.add('_hidden');
      }

    };

    spinTheWheel.addEventListener('click', spinTheWheelListener);

    if (wheelParams.animationProps.coupon) {
      const couponSelector = isMobile
        ? `.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body > .${prefix}notification__coupon`
        : `.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body > .${prefix}notification__coupon`;
      const coupon = document.querySelector(couponSelector);
      coupon.classList.add('_fadeIn');
      coupon.querySelector(`.${prefix}notification__coupon-text`).innerHTML =
        wheelParams.animationProps.coupon;

      spinTheWheel.innerHTML = 'Копировать';

    } else {
      spinTheWheel.innerHTML = 'Закрыть';
    }

    try {
      const winSectorsLength = wheelParams.sectors.length;

      const winSectorNumberInArray = wheelParams.animationProps.winSectorNumber - 1;
      const preWinSectorNumber = winSectorNumberInArray > 0 ? winSectorNumberInArray - 1 : winSectorsLength - 1;
      const afterWinSectorNumber = winSectorNumberInArray < winSectorsLength - 1 ? winSectorNumberInArray + 1 : 0;

      const wheelSectors = isMobile  ?
        `.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}mobile_wheel_filler .rotation_elements .wheelSectors`
        : `.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}desktop_wheel_filler .rotation_elements .wheelSectors`;

      const preWinElement = document.querySelector(wheelSectors).querySelector(`div[data-id="${preWinSectorNumber}"]`);
      const winElement = document.querySelector(wheelSectors).querySelector(`div[data-id="${winSectorNumberInArray}"]`);
      const afterWinElement = document.querySelector(wheelSectors)
        .querySelector(`div[data-id="${afterWinSectorNumber}"]`);

      // @ts-ignore
      const percent = winElement.attributes?.['data-percent'].value;
      // @ts-ignore
      const preWinColor = preWinElement.attributes?.['data-color'].value;
      // @ts-ignore
      preWinElement.style.background = `conic-gradient(${preWinColor} ${percent - 0.2}%, #fff ${percent}%, transparent 0)`;
       // @ts-ignore
      afterWinElement.style.background = `conic-gradient(#fff 0, ${preWinColor} 0.2% ${percent}%, transparent 0)`;
    } catch (e) {
      console.log({ e });
    }

    const titleSelector = isMobile
      ? `.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body > .${prefix}notification__title`
      : `.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body > .${prefix}notification__title`;
    const title = document.querySelector(titleSelector);
    title.innerHTML = wheelParams.sectors[wheelParams.animationProps.winSectorNumber - 1].name;


    const messageSelector = isMobile
      ? `.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body > .${prefix}notification__message`
      : `.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body > .${prefix}notification__message`;
    const message = document.querySelector(messageSelector);

    if (!wheelParams.animationProps.message) {
      message.classList.add('_fadeOut');
    } else {
      message.innerHTML = wheelParams.animationProps.message;
    }
  };

  if (spinTheWheel) {
    spinTheWheel.addEventListener('click', async (e) => {
      e.preventDefault();

      const rotatedElementSelector = isMobile
        ? `.${prefix}mobile_wheel_filler .${prefix}wheel_notification_mobile .${rotationElementsClass}`
        : `.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${rotationElementsClass}`;

      const rotatedElement = document.querySelector(rotatedElementSelector);
      rotatedElement.addEventListener('animationend', onWheelStopSpin);

      rotatedElement.classList.add(rotationWheelClass);
    });
  }
};
